export default __webpack_public_path__ + "static/media/developer-badge-low-activity-empty-state.7952f99a.svg";